import { getEnvironmentVariable } from "../global/environmentVariables";

const LANGUAGES_ARRAY =
  getEnvironmentVariable("LANGUAGES_ARRAY") &&
  getEnvironmentVariable("LANGUAGES_ARRAY") !== "NOT_SET"
    ? JSON.parse(getEnvironmentVariable("LANGUAGES_ARRAY"))
    : [];

// Defines the languages. To add a new language, simply add it to the env variable and/or the fallback array with its value and label.
// The value should match the language code used in the translation files within the /public/locales directory.

export const languages =
  LANGUAGES_ARRAY.length > 0
    ? LANGUAGES_ARRAY
    : [
        {
          value: "en-US",
          label: "English (USA)"
        }
      ];
